import client from '../client'

export const getCoordinatesKey = `${process.env.NEXT_PUBLIC_ACCOUNT_DOMAIN}/${process.env.NEXT_PUBLIC_IDENTITY_VERSION}/location/getcoordinates`

const coordsKey = '__coords__'

const memo =
  typeof window === 'undefined' ? {} : JSON.parse(localStorage.getItem(coordsKey) || '{}')

export async function getCoordinates({ zipCode }) {
  const params = new URLSearchParams({ zipCode })

  return new Promise((resolve, reject) => {
    if (memo[zipCode]) return resolve(memo[zipCode])

    client(`${getCoordinatesKey}?${params}`)
      .then((res) => {
        memo[zipCode] = res
        if (typeof window !== 'undefined') {
          localStorage.setItem(coordsKey, JSON.stringify(memo))
        }
        return resolve(res)
      })
      .catch(reject)
  })
}
